import {
    isWeb,
    ScrollView,
    SizableText,
    useMedia,
    XStack,
    YStack,
} from 'tamagui';

import { BodySmallRegular } from '../../components/text/Typography';

export const Breakpoints = () => {
    const breakpoints = useMedia();
    return (
        <YStack padding="$3" paddingTop={0} alignItems="center" width="100%">
            <BodySmallRegular paddingBottom="$3">
                The relevant breakpoint names are listed below. For the matching
                media queries, text will be shown with a demonstration of how to
                engage the media query. If there is blank space next to the
                label, that means the media query is not engaged.
            </BodySmallRegular>
            <ScrollView
                horizontal
                contentContainerStyle={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <XStack space="$2" justifyContent="center" alignItems="center">
                    <SizableText>mobile_mini:</SizableText>
                    <SizableText
                        size="$2"
                        style={{ fontFamily: 'Monospace' }}
                        opacity={0}
                        $mobile_mini={{ opacity: 1 }}
                    >
                        ✅ $mobile_mini=&#123;&#123; opacity: 1 &#125;&#125;
                    </SizableText>
                    <SizableText
                        size="$2"
                        style={{ fontFamily: 'Monospace' }}
                        opacity={breakpoints.mobile_mini ? 1 : 0}
                    >
                        ✅ opacity=&#123;breakpoints.mobile_mini ? 1 : 0&#125;
                    </SizableText>
                </XStack>
                <XStack space="$2" justifyContent="center" alignItems="center">
                    <SizableText>mobile_norm:</SizableText>
                    <SizableText
                        size="$2"
                        style={{ fontFamily: 'Monospace' }}
                        opacity={0}
                        $mobile_norm={{ opacity: 1 }}
                    >
                        ✅ $mobile_norm=&#123;&#123; opacity: 1 &#125;&#125;
                    </SizableText>
                    <SizableText
                        size="$2"
                        style={{ fontFamily: 'Monospace' }}
                        opacity={breakpoints.mobile_norm ? 1 : 0}
                    >
                        ✅ opacity=&#123;breakpoints.mobile_norm ? 1 : 0&#125;
                    </SizableText>
                </XStack>
                <XStack space="$2" justifyContent="center" alignItems="center">
                    <SizableText>mobile_plus:</SizableText>
                    <SizableText
                        size="$2"
                        style={{ fontFamily: 'Monospace' }}
                        opacity={0}
                        $mobile_plus={{ opacity: 1 }}
                    >
                        ✅ $mobile_plus=&#123;&#123; opacity: 1 &#125;&#125;
                    </SizableText>
                    <SizableText
                        size="$2"
                        style={{ fontFamily: 'Monospace' }}
                        opacity={breakpoints.mobile_plus ? 1 : 0}
                    >
                        ✅ opacity=&#123;breakpoints.mobile_plus ? 1 : 0&#125;
                    </SizableText>
                </XStack>

                <XStack space="$2" justifyContent="center" alignItems="center">
                    <SizableText>sm:</SizableText>
                    <SizableText
                        size="$2"
                        style={{ fontFamily: 'Monospace' }}
                        opacity={0}
                        $sm={{ opacity: 1 }}
                    >
                        ✅ $sm=&#123;&#123; opacity: 1 &#125;&#125;
                    </SizableText>
                    <SizableText
                        size="$2"
                        style={{ fontFamily: 'Monospace' }}
                        opacity={breakpoints.sm ? 1 : 0}
                    >
                        ✅ opacity=&#123;breakpoints.sm ? 1 : 0&#125;
                    </SizableText>
                </XStack>
                <XStack space="$2" justifyContent="center" alignItems="center">
                    <SizableText>md:</SizableText>
                    <SizableText
                        size="$2"
                        style={{ fontFamily: 'Monospace' }}
                        opacity={0}
                        $md={{ opacity: 1 }}
                    >
                        ✅ $md=&#123;&#123; opacity: 1 &#125;&#125;
                    </SizableText>
                    <SizableText
                        size="$2"
                        style={{ fontFamily: 'Monospace' }}
                        opacity={breakpoints.md ? 1 : 0}
                    >
                        ✅ opacity=&#123;breakpoints.md ? 1 : 0&#125;
                    </SizableText>
                </XStack>
                {isWeb && (
                    <>
                        <XStack
                            space="$2"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <SizableText>lg:</SizableText>
                            <SizableText
                                size="$2"
                                style={{ fontFamily: 'Monospace' }}
                                opacity={0}
                                $lg={{ opacity: 1 }}
                            >
                                ✅ $lg=&#123;&#123; opacity: 1 &#125;&#125;
                            </SizableText>
                            <SizableText
                                size="$2"
                                style={{ fontFamily: 'Monospace' }}
                                opacity={breakpoints.lg ? 1 : 0}
                            >
                                ✅ opacity=&#123;breakpoints.lg ? 1 : 0&#125;
                            </SizableText>
                        </XStack>
                        <XStack
                            space="$2"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <SizableText>short:</SizableText>
                            <SizableText
                                size="$2"
                                style={{ fontFamily: 'Monospace' }}
                                opacity={0}
                                $short={{ opacity: 1 }}
                            >
                                ✅ $short=&#123;&#123; opacity: 1 &#125;&#125;
                            </SizableText>
                            <SizableText
                                size="$2"
                                style={{ fontFamily: 'Monospace' }}
                                opacity={breakpoints.short ? 1 : 0}
                            >
                                ✅ opacity=&#123;breakpoints.short ? 1 : 0&#125;
                            </SizableText>
                        </XStack>
                        <XStack
                            space="$2"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <SizableText>tall:</SizableText>
                            <SizableText
                                size="$2"
                                style={{ fontFamily: 'Monospace' }}
                                opacity={0}
                                $tall={{ opacity: 1 }}
                            >
                                ✅ $tall=&#123;&#123; opacity: 1 &#125;&#125;
                            </SizableText>
                            <SizableText
                                size="$2"
                                style={{ fontFamily: 'Monospace' }}
                                opacity={breakpoints.tall ? 1 : 0}
                            >
                                ✅ opacity=&#123;breakpoints.tall ? 1 : 0&#125;
                            </SizableText>
                        </XStack>
                    </>
                )}
            </ScrollView>
        </YStack>
    );
};
